import comp from "./LevelsWrapper";
export default comp;
